import React from "react";
import { Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const Separator = ({
  orientation = "horizontal",
  sx = {},
  ...props
}) => {
  const theme = useTheme();

  return (
    <Divider
      orientation={orientation}
      sx={{
        borderColor: theme.palette.divider,
        ...sx,
      }}
      {...props}
    />
  );
};
